import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

export const ServerApiUrl =
  import.meta.env.VITE_SERVERAPI_URL || 'https://localhost:7044/api/';
export const ReactAppUrl = import.meta.env.VITE_APP_URL || '/';

export const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: ServerApiUrl }
  ): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig['method'];
      data?: AxiosRequestConfig['data'];
      extraOptions?: {} | undefined;
    },
    unknown,
    {} | unknown
  > =>
  async ({ url, method, data, extraOptions }) => {
    try {
      const token = localStorage.getItem('authToken');

      const config: AxiosRequestConfig = {
        url: baseUrl + url,
        method,
        data,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const result = await axios(config);
      return { data: result.data, meta: extraOptions };
    } catch (error: any) {
      const axiosError = error as AxiosError;
      console.error('axiosBaseQuery error:', {
        url: baseUrl + url,
        method,
        code: axiosError.code,
        message: axiosError.message,
        status: axiosError.response?.status,
      });
      // axios throws errors that may not have a `response` (network failure,
      // TLS rejection, CORS preflight blocked) — surface them as RTK Query
      // errors instead of masking them with `error.response.data` access.
      // The previous `window.location.reload()` on suspected-CORS errors
      // produced reload loops on persistent failures (untrusted cert, API
      // down, wrong baseUrl) and didn't even fire for most real cases —
      // axios `ERR_NETWORK` typically has `response === undefined`, so the
      // old `response?.status === 0` check almost never matched. Better to
      // surface the error and let the caller / RTK Query state machine
      // handle it (with `refetchOnMountOrArgChange` for self-healing).
      return {
        error: {
          status: axiosError.response?.status ?? axiosError.code ?? 'FETCH_ERROR',
          data: axiosError.response?.data ?? axiosError.message,
        },
      };
    }
  };
